// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-leg-selector[data-v-20a67b80]{display:grid;grid-template-columns:repeat(3,90px);gap:16px;justify-content:center;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
